import {
  extractSiteIdFromSearch,
  getCurrentSearchString,
} from 'utils/routing/urlHelpers'
import { findMatchingLessonNode } from 'utils/lms/lessonNodeHelpers'

export { resolveIndexBasedLeafNodeId } from 'utils/courseTreeHelpers'

export const resolveSiteId = ({
  explicitSiteId,
  userContext,
  locationSearch,
} = {}) => {
  if (explicitSiteId != null) return explicitSiteId
  const fromContext = userContext?.sites?.[0]?.siteId
  if (fromContext != null) return fromContext
  const search = locationSearch || getCurrentSearchString()
  return extractSiteIdFromSearch(search)
}

export const ATTEMPT_STATUS = {
  NOT_ATTEMPTED: 'not attempted',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
}

/**
 * Maps an LMS lesson_node (+ completion flag) to PresentationPlayerButton
 * attempt statuses: 'not attempted' | 'incomplete' | 'completed'.
 */
export const resolveLessonAttemptStatus = ({ isComplete, lessonNode } = {}) => {
  if (isComplete || lessonNode?.is_done) return ATTEMPT_STATUS.COMPLETED

  if (
    typeof lessonNode?.attempted === 'string' &&
    Object.values(ATTEMPT_STATUS).includes(lessonNode.attempted)
  ) {
    return lessonNode.attempted
  }

  const progress = Number(lessonNode?.progress)
  if ((Number.isFinite(progress) && progress > 0) || lessonNode?.attempt_id) {
    return ATTEMPT_STATUS.INCOMPLETE
  }

  return ATTEMPT_STATUS.NOT_ATTEMPTED
}

export const getLessonCompletionState = ({
  registrations,
  registrationId,
  courseNodeId,
  leafNodeId,
}) => {
  const defaultState = {
    isComplete: false,
    completedAt: null,
    attemptStatus: ATTEMPT_STATUS.NOT_ATTEMPTED,
    lessonNode: null,
  }
  if (!Array.isArray(registrations) || (!courseNodeId && !leafNodeId)) {
    return defaultState
  }

  const match =
    registrationId != null
      ? registrations.find(
          reg => String(reg.registration_id) === String(registrationId),
        )
      : null
  if (!match || !Array.isArray(match.lesson_nodes)) return defaultState

  const node =
    findMatchingLessonNode(match.lesson_nodes, courseNodeId) ||
    (leafNodeId
      ? match.lesson_nodes.find(n => n.leaf_node_id === leafNodeId)
      : null)

  if (!node) return defaultState

  const isComplete = !!node.is_done
  return {
    isComplete,
    completedAt: node.done_at || null,
    attemptStatus: resolveLessonAttemptStatus({ isComplete, lessonNode: node }),
    lessonNode: node,
  }
}
